import { ReactNode } from "react";
import { Client, fetchExchange, Provider } from "urql";

import appConfig from "../config.ts";
import { useTenantId } from "../hooks/useTenantId.ts";

interface Props {
  children: ReactNode;
}

export const UrqlProvider = ({ children }: Props) => {
  const { tenantId } = useTenantId();

  const client = new Client({
    url: `${appConfig.apiUrl}/graphql`,
    fetchOptions: () => {
      let headers = {};
      if (tenantId) {
        headers = { "X-Tenant-Id": tenantId };
      }
      return { credentials: "include", headers };
    },
    exchanges: [fetchExchange],
  });

  return <Provider value={client}>{children}</Provider>;
};
